// src/pages/Dashboard/components/CasePanel/AnalysisSection/AnalysisItem.js

import React, { useState } from 'react';

/**
 * Item colapsável individual da análise
 * @param {string} title - Título da seção
 * @param {string} content - Conteúdo da seção
 * @param {function} onCopy - Callback para copiar conteúdo
 */
const AnalysisItem = ({ title, content, onCopy }) => {
  const [expanded, setExpanded] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (onCopy) {
      await onCopy(content);
    }
  };

  return (
    <div className="analise-item">
      <div 
        className="analise-header" 
        onClick={() => setExpanded(!expanded)}
      >
        <span>{title}</span>
        <div className="analise-actions">
          <button 
            className="btn-copy" 
            onClick={handleCopy}
            title="Copiar conteúdo"
          >
            📋
          </button>
          <span className={`arrow ${expanded ? 'expanded' : ''}`}>▼</span>
        </div>
      </div>
      {expanded && (
        <div className="analise-content">
          <pre>{content}</pre>
        </div>
      )}
    </div>
  );
};

export default AnalysisItem;